var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"mb-2",attrs:{"block":"","variant":"success","size":"lg","href":_vm.to}},[_c('i',{staticClass:"fas fa-shopping-cart mr-1"}),_vm._v("カートをみる")])}
var staticRenderFns = []

export { render, staticRenderFns }